import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {AlgoliaManager} from '../../data/manager/algolia/algolia.manager';
import {ConfigurationManager} from '../../data/manager/configuration/configuration.manager';

@Injectable({
  providedIn: 'root',
})
export class GroupDetailVm {
  constructor(
    public algoliaManager: AlgoliaManager,
    private configurationManager: ConfigurationManager,
    private ssm: SessionStorageManager,
  ) {}

  search(query, page, facets = 'marca,categorie,subCategory,fullPrice,Prime', filters = '', sendIdStoreGroup, gtmData?): Observable<any> {
    return from(this.algoliaManager.search(query, facets, page, filters, sendIdStoreGroup, null, null, null, true))
      .pipe(
        switchMap(res => this.getOrigin(gtmData.prop)
            .pipe(
              map(origin => {
                if (res && res.hits) {
                  res.hits = res.hits.map(i => { i.rsList = origin || gtmData.gtmList; i.origin = origin; return i; });
                }
                return res;
              }),
            )),
      );
  }
  searchBrand(query, page, facets = 'categorie,subCategory,fullPrice,Prime', filters = '', sendIdStoreGroup, gtmData?): Observable<any> {
    return from(this.algoliaManager.search(query, facets, page, filters, sendIdStoreGroup))
      .pipe(
        switchMap(res => this.getOrigin(gtmData.prop)
            .pipe(
              map(origin => {
                if (res && res.hits) {
                  res.hits = res.hits.map(i => { i.rsList = origin || gtmData.gtmList; i.origin = origin; return i; });
                }
                return res;
              }),
            )),
      );
  }

  getOrigin(property): Observable<any> {
    return this.configurationManager.getOrigin(property);
  }

  getCity() {
    return this.ssm.get('city')
  }
}
